import { render, staticRenderFns } from "./partner-salesman.vue?vue&type=template&id=5cd58a4c"
import script from "./partner-salesman.vue?vue&type=script&lang=js"
export * from "./partner-salesman.vue?vue&type=script&lang=js"
import style0 from "./partner-salesman.vue?vue&type=style&index=0&id=5cd58a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports